<select class="form-control" id="stateProvinceSelect" [formControl]="stateProvince"
    [class.is-valid]="isValid" [class.is-invalid]="hasErrors"
    (change)="onSelectionChange($event)">

    <option value="">Select State / Province</option>

    @for (stateProvince of stateProvincesList(); track stateProvince.stateProvinceId) {
        <option [value]="stateProvince.stateProvinceId">{{stateProvince.name}}</option>
    }
</select>

@if (hasErrors && touched) {
    <div class="error-messages">
        @for(error of getErrors(); track $index) {
        <p class="text-danger text-start pt-1 mb-0">{{ error }}</p>
        }
    </div>
}
